import React from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import PrivacySection from "./PrivacySection";

function Privacy() {
    return (
        <div>
            <main>
                <Header />
                <PrivacySection />
            </main>
            <Footer />
        </div>
    );
}

export default Privacy;
